import React from "react";
import Select from "react-select";

const CustomSelect = ({
    name,
    value,
    options = [],
    onChange,
    labelKey = "label",
    valueKey = "value",
    placeholder = "Select",
}) => {
    console.log("OPTIONS", options)
    const selected =
        options.find((opt) => opt[valueKey] === value) || null;

    return (
        <Select
            name={name}
            options={options}
            value={selected}
            onChange={(option) =>
                onChange({
                    name,
                    value: option?.[valueKey] || "",
                    option,
                })
            }
            getOptionLabel={(opt) => opt[labelKey]}
            getOptionValue={(opt) => opt[valueKey]}
            placeholder={placeholder}
            isClearable
            styles={{
                // placeholder: (base) => ({
                //     ...base,
                //     whiteSpace: "nowrap",
                //     overflow: "hidden",
                //     textOverflow: "ellipsis",
                // }),
                control: (base) => ({
                    ...base,
                    minWidth: "160px",
                }),
            }}
        />
    );
};

export default CustomSelect;